import Vue from "vue";

import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";

Vue.component("Swiper", Swiper);
Vue.component("SwiperSlide", SwiperSlide);
